import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo, useLayoutEffect, useRef } from "react";
import { useApp } from "@/state/app-context";
import "./wip-border.scss";
export const WipBorder = memo(() => {
    const app = useApp();
    const show = app.useStore((s) => s.debug.showWipBorder);
    const overlayRef = useRef(null);
    useLayoutEffect(() => {
        if (show === false)
            return;
        const overlay = overlayRef.current;
        const parent = overlay?.parentElement;
        if (!parent)
            return;
        const prevPosition = parent.style.position;
        const computed = window.getComputedStyle(parent).position;
        if (computed === "static") {
            parent.style.position = "relative";
        }
        return () => {
            parent.style.position = prevPosition;
        };
    }, [show]);
    if (show === false)
        return null;
    return (_jsx("div", { ref: overlayRef, className: "wip-border", "aria-hidden": "true", children: _jsx("span", { className: "wip-border__label", children: "WIP" }) }));
});
